import styled from "styled-components";

export const LoginSection = styled.section`
  width: 100dvw;
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoginBox = styled.div`
  width: calc(100% - 40px);
  max-width: 530px;
  padding: 50px;
  box-sizing: border-box;
  border-radius: 10px;
  background-color: #FFFFFF;
`;

export const LoginInputBox = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  box-sizing: border-box;
  border: 1px solid #ECEEF2;
  border-radius: 6px;
`;

export const LoginInput = styled.input`
  width: calc(100% - 29px);
  height: 38px;
  font-weight: 500;
  border: none;
  outline: none;
`;

export const AlertMessage = styled.span`
  width: 100%;
  height: 30px;
  display: block;
  color: #E84558;
  opacity: 0;
  
  &.active {
    opacity: 1;
  }
`;

export const LoginBtn = styled.button`
  width: 100%;
  height: 40px;
  padding: 0;
  color: #FFFFFF;
  font-weight: 700;
  border-radius: 6px;
  background-color: #0764A9;
`;

export const LoginLinkBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ACB2B8;

  a {
    font-weight: 500;
  }
`;